module.exports = __webpack_public_path__ + "img/services.48a1a743.svg";